import React, { FormEvent, ReactElement } from 'react';
import {
  Button, Heading, LoaderButton, Text,
} from 'idsk-react-components';
import LegislativnyMaterialCreateUpdate
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import LegMaterialCreateStepEnum
  from '../../../../model/legislativnyMaterial/LegMaterialCreateStepEnum';
import CheckDataTable from '../component/CheckDataTable';
import './checkDataStepFive.scss';

interface Props {
  legislativnyMaterial: LegislativnyMaterialCreateUpdate;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: LegMaterialCreateStepEnum) => void;
  loading: boolean;
  onChangeStep: (nextStep: LegMaterialCreateStepEnum) => Promise<void>;
  isUpdate?: boolean;
}

const CheckDataStepFive = ({
  onSubmit,
  legislativnyMaterial,
  loading,
  onChangeStep,
  isUpdate = false,
}: Props): ReactElement => (
  <div className="check-data-step-five">
    <Heading className="page-title" size="xl">Skontrolujte zadané údaje</Heading>
    <CheckDataTable
      legislativnyMaterial={legislativnyMaterial}
      onChangeStep={onChangeStep}
      isUpdate={isUpdate}
    />
    {!isUpdate && (
    <Text className="check-data-step-five__submit-message">
      Kliknutím na Dokončiť vytvorenie sa vytvorí legislatívny proces,
      bude mu pridelené číslo a budete môcť pridávať sprievodnú dokumentáciu.
    </Text>
    )}
    <LoaderButton
      className="legislativny-material-create__submit-button"
      loading={loading}
      type="submit"
      size="large"
      onClick={(e) => onSubmit(e, LegMaterialCreateStepEnum.CREATE_UPDATE_6)}
      disableOutsideClickWhileLoading
    >{isUpdate ? 'Dokončiť úpravu' : 'Dokončiť vytvorenie'}
    </LoaderButton>
    <Button
      className="legislativny-material__button"
      type="button"
      buttonStyle="third"
      size="large"
      disabled={loading}
      onClick={() => onChangeStep(legislativnyMaterial.typ?.kod === 'AktEU'
        ? LegMaterialCreateStepEnum.RELATED_DATA_3 : LegMaterialCreateStepEnum.PREDKLADATEL_4)}
    >
      Späť
    </Button>
  </div>
);
export default CheckDataStepFive;
